import Swiper from "swiper";
import { Navigation } from "swiper/modules";

// Import Swiper styles needed
import "swiper/css";
import "swiper/css/navigation";

function initFeaturedCategoriesCarousel() {
  const carouselElement = document.querySelector(
    ".featured-categories-carousel"
  );

  if (!carouselElement) {
    return;
  }

  // Initialize Swiper
  const swiper = new Swiper(carouselElement, {
    modules: [Navigation],

    spaceBetween: 20,
    slidesPerView: 2,
    loop: false,

    // --- CHANGE: Use specific navigation selectors ---
    navigation: {
      nextEl: ".featured-categories-next",
      prevEl: ".featured-categories-prev",
    },
    // --- END CHANGE ---

    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 20,
      },
    },
  });
}

// Run the initialization
if (
  document.readyState === "complete" ||
  document.readyState === "interactive"
) {
  initFeaturedCategoriesCarousel();
} else {
  document.addEventListener("DOMContentLoaded", initFeaturedCategoriesCarousel);
}
